import React from 'react';
import './Thanks.css';
import Footer from '../../Footer';

function Thanks (){
    return (
        <div className='App'>
            <meta name="viewport" content="initial-scale=1, width=device-width" />            
            <header className='like'>                               
                <img src="/imagens/like.png" alt="Like Magalu" className='thanks-image'></img>
                <h1> Obrigado</h1>
                <p>Sua opinião é muito importante para nós!</p>                               
            </header>
            <Footer>@2024 Magazine Luiza</Footer>
        </div>          

    );
};
export default Thanks;